import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';
import { FilePond, registerPlugin } from 'react-filepond';
import { create } from '../../react-doka/lib/doka.esm.min';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginImageEdit from 'filepond-plugin-image-edit';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginImageResize from 'filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

import ReviewComponent from '../global/review-component';
import ReviewAverageComponent from '../global/review-average-component';
import AboutMeForm from './forms/aboutMeForm';

import { getUserProfileInfo, updateProfilePhoto, updateAboutMe, addResponseToReview, addResponseToListingReview, syncBillingAddress } from './actions';
import { checkAuthorization } from '../global/actions';
import { generateFileUrl } from '../../apiHelper';
import { fileBaseUrl } from '../../config';
import { USER_PLACEHOLDER } from '../../constants/images';

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImageCrop,
  FilePondPluginImageResize,
  FilePondPluginImagePreview,
  FilePondPluginImageEdit,
  FilePondPluginImageTransform,
  FilePondPluginFileValidateType
)

const mapStateToProps = state => ({
  global: state.Global,
  profile: state.User.user
});

export const cropProps = {
  aspectRatio: 1,
  center: {
    x: 0.5378,
    y: 0.355
  }
};

export const cropMask = (root, setInnerHTML) => {
  // https://pqina.nl/doka/docs/patterns/api/doka-instance/#setting-the-crop-mask
  setInnerHTML(root, `
        <mask id="my-mask">
            <rect x="0" y="0" width="100%" height="100%" fill="white"/>
            <circle cx="50%" cy="50%" r="50%" fill="black"/>
        </mask>
        <rect fill="rgba(255,255,255,.3125)" x="0" y="0" width="100%" height="100%" mask="url(#my-mask)"/>
        <circle cx="50%" cy="50%" r="50%" fill="transparent" stroke-width="1" stroke="#fff"/>
    `);
};

class ProfileComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      canEdit: props.profile ? props.profile.userId === props.global.userID : false,
      isEditingProfile: false,
      syncAddressCount: 0,
      reviewType: props.profile
        ? props.profile.userType
        : '',
      profilePic: []
    }

    this.toggleEditProfile = this.toggleEditProfile.bind(this);
  }

  setInitialState() {
    if ((this.props.profile && this.props.global)
      && (this.props.profile.userId === this.props.global.userId)
      && !this.state.canEdit) {
      this.setState({ canEdit: true });
    } else if (this.state.canEdit !== false) {
      this.setState({ canEdit: false });
    }
    if (this.props.profile && !this.state.reviewType) {
      this.setState({ reviewType: this.props.profile.userType })
    }

    if (this.props.profile && this.props.profile.profile.photo) {
      this.setState({
        profilePic: [{
          source: this.props.profile.profile.photo,
          options: { type: 'local' }
        }]
      });
    }
  }

  componentDidUpdate(prevProps) {
    let { dispatch } = this.props;
    let syncAddressCount = this.state.syncAddressCount;
    let user = this.props.profile;
    if (!prevProps.profile && this.props.profile
      || (prevProps.profile && prevProps.profile._id !== this.props.profile._id)) {
      this.setInitialState();
      let userType = user.userType === 'owner' ? 'Account' : 'Customer';
      let blueSwipeUserId = userType === 'Account' ? user.accountId_blueSwipe : user.customerId_blueSwipe;
      if ((blueSwipeUserId !== "" && blueSwipeUserId !== null) && syncAddressCount === 0) {
        dispatch(syncBillingAddress(user._id, blueSwipeUserId, userType));
        syncAddressCount++;
        this.setState({ syncAddressCount });
      }
    }
  }

  componentDidMount() {
    this.setInitialState();
  }

  componentWillMount() {
    let { dispatch, history, match, global } = this.props;
    let { id } = match.params;
    if (!id) {
      history.push('/login');
    }
    if (global.userId) {
      dispatch(checkAuthorization());
    }
    dispatch(getUserProfileInfo(id));
  }

  toggleEditProfile() {
    this.setState({ isEditingProfile: !this.state.isEditingProfile });
  }

  profileOnSubmit = (values, { setSubmitting }) => {
    let { dispatch } = this.props;
    dispatch(updateAboutMe(values));
    this.toggleEditProfile();

  }

  profileOnCancel = () => {
    this.toggleEditProfile();
  }

  renderEditableProfileInfo(profile) {
    return (<div className="col"><AboutMeForm onSubmit={this.profileOnSubmit} onCancel={this.toggleEditProfile} profile={profile} /></div>)
  }

  renderReadOnlyProfileInfo(profile) {
    let { canEdit } = this.state;
    let loyalties = (profile.profile.loyalties && profile.profile.loyalties.length > 0)
      ? (<div className="mt-3"><h3>Loyalties</h3><ul>{profile.profile.loyalties.map((l, i) => { return (<li key={i}>{l}</li>) })}</ul></div>)
      : (<div />);

    if (canEdit) {
      return (<div className="col">
        <div className="row">
          <div className="col-md-12"><h2>About Me</h2></div>
          {canEdit && (<div className="col-md-12"><button className="btn btn-secondary btn-edit" onClick={this.toggleEditProfile}>Edit</button></div>)}
        </div>
        <div>{profile.profile.about ? profile.profile.about : `No profile information has been uploaded.`}</div>
        <div className="mt-3"><strong>Member Since:</strong> {moment(profile.createdDate).format('MMMM YYYY')}</div>
        {loyalties}
      </div>)
    } else {
      return (<div className="col">
        <h2>About Me</h2>
        <div>{profile.profile.about ? profile.profile.about : `No profile information has been uploaded.`}</div>
        <div className="mt-3"><strong>Member Since:</strong> {moment(profile.createdDate).format('MMMM YYYY')}</div>
        {loyalties}
      </div>)
    }
  }

  handleProcess = (name, file, metadata, load) => {
    let { dispatch } = this.props;
    let photo = file;

    if (photo) {
      let promise = dispatch(updateProfilePhoto(photo));
      promise.then((data) => {
        this.setState({
          profilePic: [{
            source: photo,
            options: { type: 'local' }
          }]
        })
        load(Date.now());
      });
    }
  }

  newUpload = () => {
    this.pond.browse();
  }

  reviewResponseOnSubmit = (values) => {
    let { dispatch } = this.props;
    if (this.state.reviewType === 'owner') {
      dispatch(addResponseToListingReview(values.reviewId, values.response));
    } else {
      dispatch(addResponseToReview(values.reviewId, values.response));
    }
  }

  reviewToggle(reviewType) {
    this.setState({ reviewType: reviewType })
  }

  renderReviewToggle() {
    return (<div className="row rating-toggle"><div className="col">
      <span className={this.state.reviewType === 'owner' ? 'selected' : ''} onClick={() => this.reviewToggle('owner')}>As an <strong>owner</strong></span>
      <span className={this.state.reviewType !== 'owner' ? 'selected ml-3' : 'ml-3'} onClick={() => this.reviewToggle('renter')}>As a <strong>renter</strong></span>
    </div></div>)
  }

  renderReviews(reviews, canEdit, name) {
    return (<div className="row">
      <div className="col-12 mt-3 mb-3">
        <ReviewAverageComponent reviews={reviews} />
      </div>
      <div className="col">
        {reviews && reviews.sort(this.compareReviews).map(r => <ReviewComponent key={r._id} review={r} type={this.state.reviewType}
          onSubmit={this.reviewResponseOnSubmit} showReviewResponseForm={canEdit} responderName={name} />)}
      </div>
    </div>);
  }

  compareReviews(a, b) {
    let aDate = new Date(a.createdDate);
    let bDate = new Date(b.createdDate);
    if (aDate > bDate) { return -1 }
    if (aDate < bDate) { return 1; }
    return 0;
  }

  render() {
    let { profile } = this.props;
    let { canEdit, isEditingProfile, reviewType } = this.state;

    if (!profile) { return (<div>Loading Profile...</div>) }
    let imageServerUrl = `${fileBaseUrl}/${profile.userId}/`;
    let reviews = reviewType === 'owner' ? profile.listingReviews : profile.reviews;
    let profileName = `${profile.firstName} ${profile.lastName.substr(0, 1)}.`; //`

    let profilePic = USER_PLACEHOLDER;
    if (!!this.state.profilePic.length)
      profilePic = generateFileUrl(this.state.profilePic[0].source, profile.userId);

    return (<div className="container profile-container">
      <div className="row">
        <div className="col"><h1>{profileName}</h1></div>
      </div>
      <div className="row">
        <div className="col-md-6 mt-3">
          {canEdit ?
            <FilePond
              ref={ref => (this.pond = ref)}
              files={this.state.profilePic}
              labelIdle='<span class="filepond--label-action">Upload Image</span>'
              allowMultiple={false}
              acceptedFileTypes={['image/png', 'image/jpeg', 'image/tiff']}
              imageCropAspectRatio='1:1'
              imagePreviewHeight={150}
              stylePanelLayout='compact circle'
              styleLoadIndicatorPosition='center bottom'
              styleProgressIndicatorPosition='right bottom'
              styleButtonProcessItemPosition='right bottom'
              server={{
                load: imageServerUrl,
                process: this.handleProcess
              }}
              imageEditEditor={create({
                crop: cropProps,
                cropMask: cropMask
              })}
            /> :
            <div className="profile-photo">
              <img src={profilePic} alt="" />
            </div>
          }
          {canEdit && <button className="btn btn-secondary" onClick={() => this.newUpload()}>Change Photo</button>}
        </div>
        {isEditingProfile ? this.renderEditableProfileInfo(profile.profile) : this.renderReadOnlyProfileInfo(profile)}
      </div>
      <div className="row mt-3">
        <div className="col-12">
          <h5>Ratings &amp; Reviews</h5>
        </div>
      </div>
      {profile.userType === 'owner' && this.renderReviewToggle()}
      {this.renderReviews(reviews, canEdit, profileName)}
    </div>);

  }
}

export default withRouter(connect(mapStateToProps)(ProfileComponent));
